<template>
    <!-- Teleport escapes ancestor stacking contexts (e.g. the banner's `isolate`),
         which would otherwise let later page content paint over the fixed overlay. -->
    <Teleport to="body">
        <div v-if="isOpen" class="fixed inset-0 z-20 flex items-center justify-center bg-slate-900/45 p-4 sm:p-6" @click.self="closeModal">
        <div class="relative flex w-full max-w-2xl max-h-[88dvh] flex-col overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-custom-xl" role="dialog" aria-modal="true" :aria-labelledby="headerId" ref="modalEl" tabindex="-1">
            <button type="button" @click="closeModal" class="absolute right-3 top-3" aria-label="Close dialog">
                <i class="icon-close-light text-xl text-slate-600"></i>
            </button>

            <div class="border-b border-slate-100 px-4 py-3 pr-12" v-if="$slots.header">
                <strong class="flex flex-col items-start gap-1.5 text-base text-slate-800" :id="headerId">
                    <slot name="header" />
                </strong>
            </div>

            <div class="flex-1 overflow-y-auto p-4">
                <slot />
            </div>

            <div class="mt-auto space-x-3 border-t border-slate-100 bg-white p-4 text-center" v-if="$slots.footer">
                <slot name="footer" />
            </div>
            </div>
        </div>
    </Teleport>
</template>

<script setup>
const isOpen = ref(false)
const modalEl = ref(null)
const lastFocusedEl = ref(null)
const headerId = `modal-title-${Math.random().toString(36).slice(2)}`

const openModal = async () => {
    lastFocusedEl.value = document.activeElement
    isOpen.value = true
    await nextTick()
    modalEl.value?.focus()
}

const closeModal = () => {
    isOpen.value = false
    lastFocusedEl.value?.focus()
}

const onKeydown = (e) => {
    if (e.key === 'Escape' && isOpen.value) {
        e.stopPropagation()
        closeModal()
    }
}

watch(isOpen, (value) => {
    document.body.classList.toggle('overflow-hidden', value)
})

onMounted(() => {
    document.addEventListener('keydown', onKeydown)
})

onBeforeUnmount(() => {
    document.removeEventListener('keydown', onKeydown)
})

defineExpose({
    isOpen,
    openModal,
    closeModal
})
</script>
